import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDisabledAddCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle cx={16} cy={16} r={15.5} stroke="#999" />
    <rect width={1.714} height={12} x={15.143} y={10} fill="#999" rx={0.857} />
    <rect
      width={1.714}
      height={12}
      x={22}
      y={15.143}
      fill="#999"
      rx={0.857}
      transform="rotate(90 22 15.143)"
    />
  </svg>
);
export default SvgDisabledAddCircleIcon;
